/// <amd-module name="ClemtexPay.Checkout.Config"/>
//
// Settings for the checkout card step. Kept in one place so a redeploy of the
// extension is the only way they change (no SCA Configuration page entry —
// see the Configuration-schema gotcha in the SCEDT CLAUDE.md).
//
define('ClemtexPay.Checkout.Config', [], function () {
    'use strict';
    return {
        // Logged-in actions: same-origin call inside the shopper's session, so the
        // Suitelet resolves the customer from runtime.getCurrentUser() — never from
        // anything we send. (Same pattern as the My Account "Pay Now" bridge.)
        CHECKOUT_URL: '/app/site/hosting/scriptlet.nl' +
            '?script=customscript_bb_sl_web_checkout' +
            '&deploy=customdeploy_bb_sl_web_checkout',

        // Pre-login terms flip: the PUBLIC (Available Without Login) deployment's
        // EXTERNAL URL (customdeploy_bb_sl_web_checkout_public, deployment 10430,
        // script 3478), copied from the deployment record on 2026-10-07. The
        // ns-at= token is NetSuite's signed hash — redeploying the script keeps
        // it; deleting/recreating the deployment changes it. Empty = hook off.
        PRELOGIN_URL: 'https://608324.extforms.netsuite.com/app/site/hosting/scriptlet.nl' +
            '?script=3478&deploy=2&compid=608324' +
            '&ns-at=AAEJ7tMQNsrtNbQksW5T10M8CTajoZgQ2YKzkD0K-vvoWHFnD8E',
        PRELOGIN_TIMEOUT_MS: 2500,

        // Names of the placeholder terms record (must match bb_stripe_lib's
        // PAY_BY_LINK_TERM_ALIASES). Compared against profile.paymentterms.name.
        // Renamed 'Pay by Link' → 'Web Credit Card' on 2026-10-07; both accepted.
        PAY_BY_LINK_TERM_NAMES: ['Web Credit Card', 'Pay by Link'],

        // Where the card step is added: Standard checkout's Payment page.
        PAYMENT_STEP_URL: 'billing',
        PAYMENT_STEP_MODULE_INDEX: 1,

        STRIPE_JS_URL: 'https://js.stripe.com/v3/',
        // Preselected country in the card form (ISO 3166-1 alpha-2).
        DEFAULT_CARD_COUNTRY: 'US',
        CONSENT_TEXT: 'Your card will be charged when your order ships. For orders that ship in ' +
            'more than one shipment, each shipment is charged separately. Nothing is charged today.'
    };
});
